module.exports = __webpack_public_path__ + "3a27652766a286f124d32ab130ebace4.MP3";